import React from 'react'
import { useAppointmentCalendar } from '@context/AppointmentCalendarContext/AppointmentCalendarContext'
import useStyles from './styles'
import clsx from 'clsx'
import { ReactComponent as IconChevronRight } from 'src/images/icon-chevron-right.svg'
import { CALENDAR_DIRECTIONS } from '@customTypes/AppointmentCalendarDirections'
import { CALENDAR_USER_ACTIONS } from '@customTypes/AppointmentCalendarUserActions'
import logUserInteraction from 'src/react/screens/Appointment/helpers/logUserInteraction'

export const GoNextArrow = () => {
  const { goToNextPeriod, isTransitioning, swipeToPeriod } = useAppointmentCalendar()

  const classes = useStyles()

  const goNext = () => {
    if (!isTransitioning) {
      logUserInteraction(CALENDAR_DIRECTIONS.LEFT, CALENDAR_USER_ACTIONS.ARROW_CLICK)

      swipeToPeriod(CALENDAR_DIRECTIONS.NEXT)
    }
  }

  return (
    <IconChevronRight
      data-test={goToNextPeriod ? 'next-week' : ''}
      className={clsx(classes.control, classes.nextArrowWeekdayView, {
        [classes.controlLastPeriod]: !goToNextPeriod || isTransitioning,
      })}
      onClick={goNext}
    />
  )
}
